import React from "react";
import "./FleetCoreDailyCheckInCheckOut.css";

import fleetcoreDailyCheckInCheckOutPhotoJpg from "../../images/south-african-mine-bakkie-inspection.png";
import fleetcoreDailyCheckInCheckOutPhotoWebp from "../../images/south-african-mine-bakkie-inspection.webp";
import fleetcoreDailyCheckInCheckOutTimelineDesktop from "../../images/fleetcore-daily-check-in-check-out-shift-timeline-desktop.svg";
import fleetcoreDailyCheckInCheckOutTimelineMobile from "../../images/fleetcore-daily-check-in-check-out-shift-timeline-mobile.svg";

export default function FleetCoreDailyCheckInCheckOut() {
  return (
    <section className="fleetcore-daily-check-in-check-out" id="fleetcore-shifts" aria-labelledby="fleetcore-daily-check-in-check-out-title">
      <div className="fleetcore-daily-check-in-check-out__inner">
        <div className="fleetcore-daily-check-in-check-out__copy">
          <p className="fleetcore-daily-check-in-check-out__eyebrow">EVERY SHIFT, ACCOUNTED FOR</p>
          <h2 id="fleetcore-daily-check-in-check-out-title">Start and end every shift with evidence.</h2>
          <p className="fleetcore-daily-check-in-check-out__body">The driver links to the assigned vehicle, captures the walk-around and dashboard, then repeats the process at checkout. FleetCore compares the two and files one shift report.</p>
        </div>
        <div className="fleetcore-daily-check-in-check-out__photo-wrap">
          <picture><source srcSet={fleetcoreDailyCheckInCheckOutPhotoWebp} type="image/webp" /><img src={fleetcoreDailyCheckInCheckOutPhotoJpg} alt="Fleet driver photographing a delivery vehicle during a pre-shift walk-around inspection" /></picture>
        </div>
        <picture className="fleetcore-daily-check-in-check-out__timeline">
          <source media="(max-width: 699px)" srcSet={fleetcoreDailyCheckInCheckOutTimelineMobile} />
          <img src={fleetcoreDailyCheckInCheckOutTimelineDesktop} alt="Check-in, capture, operate and check-out shift evidence sequence" />
        </picture>
        <p className="fleetcore-daily-check-in-check-out__principle">Same driver. Same vehicle. Two evidence points.</p>
      </div>
    </section>
  );
}